const PHRASE = "Complete Dental Care — For You & Your Family — Smart Dental Clinic — ";

export const Marquee = () => (
  <div
    aria-hidden="true"
    data-testid="editorial-marquee"
    className="select-none overflow-hidden border-y border-[#D4AF37]/20 bg-[#0F574E] py-5"
  >
    <div className="animate-marquee-slow flex w-max whitespace-nowrap">
      {[0, 1].map((i) => (
        <span
          key={i}
          className="font-display pr-6 text-[clamp(3.5rem,9vw,8rem)] leading-none tracking-tight text-[#FDFCF8]/[0.09]"
        >
          {PHRASE}
        </span>
      ))}
    </div>
  </div>
);
